export const DISCUSS_TARGET_CODE_TYPES = {
  O2O: 'o2o',
  KNG: 'kng'
};
